type RumErrorEvent = {
  type?: string;
  error?: { source?: string; csp?: unknown; stack?: string };
};

const EXTENSION_SOURCE = /@ (?:chrome|moz|safari|safari-web)-extension\b/;

/**
 * CSP violation reports raised by code a browser extension injects into the
 * page. The policy already blocks the code; the reports are noise that can
 * reach thousands per minute from a single user.
 */
export function isBrowserExtensionCspReport(event: RumErrorEvent): boolean {
  return (
    event.type === "error" &&
    event.error?.source === "report" &&
    event.error.csp !== undefined &&
    EXTENSION_SOURCE.test(event.error.stack ?? "")
  );
}
